<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg
            :headerText="lbl.privacymenu.title"
            small
            :canGoBack="true"
        ></TopBarBg>
        <PageContent
            class="flex-auto px-6"
            :hasPoweredBy="hasPoweredBy"
            rounded
            :marginTop="55"
            :paddingTop="0">

            <div class="menu-wrapper">
                <div class="grid grid-cols-2 mt-10 border-b border-light-blue-1 pb-5 items-center" @click="goto('marketingsetting')">
                    <div>{{lbl.privacymenu.mkt}}</div>
                    <div class="text-right ml-auto"><img src="../../assets/icon/arrow/arrow-chevron-right.svg" /></div>
                </div>
                <div class="grid grid-cols-2 border-b mt-5 border-light-blue-1 pb-5 items-center" @click="goto('copydata')">
                    <div>{{lbl.privacymenu.copy_Data}}</div>
                    <div class="text-right ml-auto"><img src="../../assets/icon/arrow/arrow-chevron-right.svg" /></div>
                </div>
                <div class="grid grid-cols-2 border-b mt-5 border-light-blue-1 pb-5 items-center" @click="goto('tranferdata')">
                    <div>{{lbl.privacymenu.tranfer_data}}</div>
                    <div class="text-right ml-auto"><img src="../../assets/icon/arrow/arrow-chevron-right.svg" /></div>
                </div>
            </div>
        </PageContent>
        <div class="text-center text-sm mb-6 flex items-center justify-center">{{lbl.privacymenu.contact_callcenter}}
            <img class="h-4 w-auto" src="../../assets/icon/ic-phone.png"/> <a class="text-primary underline" href="tel:026451212">{{lbl.privacymenu.contact_phone}}</a>
        </div>
        <Footer :hasPoweredBy="false"></Footer>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager";
//component
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue";
import PageContent from "@/components/Layout/Content/PageContent.vue";
//mixin
import AuthPageMixin from "@/mixin/AuthPageMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//service
import {
    PurchaseFilterConfigBuilder,
    PurchaseListConfigBuilder,
} from "@/core/History/config/HistoryConfigModel.js";
import Footer from "@/components/Layout/Footer/Footer.vue";
// import { HistoryPointConfigBuilder } from "@/core/Point/config/PointConfigModel.js";

export default {
    name: "History",
    mixins: [ModalMixin, AuthPageMixin, LocaleMixin],
    components: {
        TopBarBg,
        PageContent,
        Footer,
    },
    data: function () {
        return {
            purchaseListConfig: null,
            purchaseFilterListConfig: null,
            tab: 0,
            tabs: ["Redeemed", "Used / Expired"],
            isExpired: false,
            hasPoweredBy: false,
            trackingScreenName: "",
        };
    },
    created: function () {
        this.tracking.screenName(this.trackingScreenName);
    },
    mounted: async function () {
        // this.loadingModal.show();
        // await this.$refs["history-list"].getList();
        // this.loadingModal.hide();
    },
    beforeUnmount: function () {
        window.onscroll = null;
    },
    methods: {
        //#region mixin
        onSetupModalCompleted: function () {
            this.initialHistoryModal();
        },
        //#endregion mixin
        setScrollLoadMore: function () {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },

        setupHistoryList: async function () {
            const configs = ConfigManager.getHistoryConfig();
            let config = this.tab == 0 ? configs.purchaseUnused : configs.purchaseUsed;
            this.purchaseListConfig = new PurchaseListConfigBuilder()
                .setConfigList(config)
                .setType("list")
                .setTop(25)
                .create();

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder().create();
            this.purchaseFilterListConfig = filterListConfig;

            if (this.$refs["history-list"]) {
                this.$refs["history-list"].reinitList(
                    this.purchaseListConfig,
                    this.purchaseFilterListConfig
                );
            }
        },

        loadMore: async function () {
            this.loadingModal.show();
            await this.$refs["history-list"].loadMore();
            this.loadingModal.hide();
        },

        setTracking: function (selectedTab) {
            let trackCategory = selectedTab == 0 ? "tab_redeemed" : "tab_used";
            let trackAction =
                selectedTab == 0 ? "click_tab_redeemed" : "click_tab_used";
            this.tracking.event(trackCategory, trackAction, null, null);
        },
        goto: function (path) {
            this.$router.push(path);
        }
    },
};
</script>
<style lang="scss" scoped>
</style>
